/**************************************************
 * Nombre:       Tarjeta_Epacio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import Boton from "../Secciones/Componentes/SubComponentes/Boton";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Espacio from "../Dialogos/Dialogo_Espacio";

const Tarjeta_Epacio = ({item}) => {
    const {sCell} = useResponsive()
    const {Dialogo, cerrar, abrir} = useDialogo({Componente: Dialogo_Espacio, titulo: 'Regisitro'})


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: 'linear-gradient(14deg, rgba(0, 0, 0, 50) 20.95%, rgba(255, 255, 255, 0.00) 56.56%), url(' + item.img + ')',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top center',
                borderRadius: 4,
                p: sCell ? 4 : 6,
                minHeight: sCell ? 550 : 650
            }}
        >

            <Dialogo/>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{color: '#fff', fontSize: sCell ? 30 : 32, fontWeight: 800, lineHeight: 1.2}}>
                            <span style={{
                                color: theme.palette.primary.main,
                                paddingRight: 5
                            }}>{item.nombreResaltado}</span>
                            {item.nombre}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                        <Typography sx={{
                            color: '#fff',
                            fontSize: sCell ? 14 : 16,
                            fontWeight: 300,
                            lineHeight: 1.2
                        }}>{item.subtitulo}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                        <Typography sx={{
                            color: '#fff',
                            fontSize: sCell ? 14 : 18,
                            fontWeight: 600,
                            lineHeight: 1.2
                        }}>{item.fecha}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                        <Typography sx={{
                            color: '#fff',
                            fontSize: sCell ? 14 : 18,
                            fontWeight: 600,
                            lineHeight: 1.2
                        }}>{item.hora}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-end', mt: sCell ? 3 : 2}}>
                        <Boton
                            habilitado={true}
                            click={() => abrir({
                                espacio: item.nombreResaltado + ' ' + item.nombre,
                                hora: item.hora,
                                fechaEspacio: item.fecha,
                                profesional: item.subtitulo,
                            })}
                            texto={'Registro Gratis'}/>
                    </Grid>


                </Grid>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Epacio    